module.exports = __webpack_public_path__ + "static/PAKDReel-be3a828c63b95c0a0f7213b77b106b2d.webm";